export default {
    gameWidth: 1280,
    gameHeight: 720,
    actualWidth: 0,
    actualHeight: 0,
    viewWidth: 0,
    viewHeight: 0,
    fullWidth: 0,
    fullHeight: 0
};


//////////////////
// WEBPACK FOOTER
// ./src/dimensions.js
// module id = 28
// module chunks = 0